module.exports = __webpack_public_path__ + "img/132.4.57819d91.png";